import { AbstractAjaxLoader, AjaxLoaderOptions } from "./AbstractAjaxLoader.js";
import { registerLoader } from "./AbstractLoader.js";

export interface BlobLoaderOptions extends AjaxLoaderOptions {

}

export class BlobLoader extends AbstractAjaxLoader<Blob, BlobLoaderOptions>{
    protected defaultOptions(): BlobLoaderOptions {
        return {
            decoder: "blob"
        }
    }
}

registerLoader("blob", BlobLoader);